import React from 'react';
import { Col, Form, Input, InputNumber, Row, Select } from 'antd';
import ModalForm from 'components/modal-form/modal-form.component';
import { MarkForSaleFragmentProps } from './interfaces';
import { useMarkForSaleController } from './mark-for-sale.controller';

export const MarkForSaleFragment: React.FC<MarkForSaleFragmentProps> = (props) => {
    const { useController = useMarkForSaleController } = props;
    const controller = useController(props);

    return (
        <ModalForm
            title="Agregar propiedad a ventas"
            isvisible={props.isVisible}
            onCancel={props.onCancel}
            onFinish={controller.onFormSubmit}
            form={controller.form}
            isLoading={controller.isLoading}
            layout="vertical"
            okButtonLabel="Agregar"
        >
            <Row gutter={12}>
                <Col xs={24}>
                    <Form.Item
                        label="Propiedad"
                        name="propertyId"
                        rules={[{ required: true, message: 'Seleccioná una propiedad' }]}
                    >
                        <Select
                            showSearch
                            loading={controller.isFetchingProperties}
                            options={controller.propertyOptions}
                            placeholder="Buscar propiedad..."
                            optionFilterProp="label"
                        />
                    </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                    <Form.Item label="Precio" name="price" rules={[{ required: true, message: 'Ingresá el precio' }]}>
                        <InputNumber style={{ width: '100%' }} min={0} />
                    </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                    <Form.Item label="Moneda" name="currency" initialValue="USD" rules={[{ required: true }]}>
                        <Select
                            options={[
                                { value: 'USD', label: 'USD' },
                                { value: 'ARS', label: 'ARS' },
                            ]}
                        />
                    </Form.Item>
                </Col>
                <Col xs={24}>
                    <Form.Item label="Descripción (opcional)" name="description">
                        <Input.TextArea rows={3} placeholder="Describí la propiedad para la publicación..." />
                    </Form.Item>
                </Col>
            </Row>
        </ModalForm>
    );
};
